import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import _ from "lodash";
import * as R from 'ramda';
import { toast } from "react-toastify";
import { useAppDispatch } from "../../hooks/hooks";
import { selectSettings } from "../../redux/settings/selectors";
import storePersist from "../../redux/storePersist";
import { selectAccountTypesListItems } from "../../redux/account-types/selector";
import { accountTypes } from "../../redux/account-types/action";
import { accounts } from "../../redux/accounts/action";
import { InputContainer } from "../../common/components/form/form.module";
import PageLoader from "../../components/PageLoader";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import { RotatingLines } from "react-loader-spinner";

export const RegisterTransporter = () => {
	const navigate = useNavigate()
	const dispatch = useAppDispatch()
	const { height, width } = useWindowDimensions();
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const { register, clearErrors, formState: { errors }, setValue } = useForm();
	const [steps, setSteps] = useState({ FirstName: '', LastName: '' })
	const handleSteps = (e: any, key: any) => {
		setSteps({ ...steps, [key]: e.target.value })
	}
	const [color, setColor] = useState('universal')
	const defaultSetting = useSelector(selectSettings)
	const { theme } = defaultSetting
	const statesItems = storePersist?.get("states")?.current?.items;
	const countriesItems = storePersist?.get("countries")?.current?.items;
	const accountTypeItems = useSelector(selectAccountTypesListItems)
	useEffect(() => {
		handleFilterToStates(133); //Filtering states of India
		dispatch(accountTypes.list({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`, entity: 'accountTypes', jsonData:
				{ "PageNumber": 1, "PageSize": 10000, "SortField": "Id", "SortOrder": "desc" }
		}))
	}, []);
	const [
		accountData,
		setAccountData
	] = useState<any>({
		LoginInfo: {},
		UserInfo: {},
		AccountInfo: {
			IsPersonAccount: true,
			IsCustomerPortalEnabled: false,
			IsVendorPortalEnabled: false,
			IsPartnerEnabled: false,
			IsAccountVerified: true,
			IsGuestAccessEnabled: true,
			IsLimitedToOrganizationUnit: false,
			EnableOnNetworkLogisticsSupport: true,
			MappedAccountTypes: {}
		},
		AccountAddress: {},
		Address: {}
	})
	const [
		stateValues,
		setStateValues
	] = useState<any>([])
	const handleFilterToStates = (event: any) => {
		handleInnerFormChange(
			event,
			'Address.CountryId',
			accountData?.Address
		);
		if (event) {
			const filterStates: any = R.filter(
				(value: any) => value.CountryId === event,
				statesItems
			);
			if (filterStates.length) {
				setStateValues(filterStates);
			} else {
				setStateValues(statesItems);
			}
		} else {
			setStateValues([])
		}
	}
	useEffect(() => {
		setColor(theme)
	}, [theme]);
	const handleInnerFormChange: any = (event: any, field: string, data: any) => {
		const fields = R.split(
			'.',
			field
		);
		const value = { ...data, [fields[1]]: event }// inner data update
		setAccountData({ ...accountData, [fields[0]]: value });
	}
	const handleClose = () => {
		setAccountData({})
		navigate('/auth/login/transporter')
	}
	const handleSubmit = async (event: any) => {
		event.preventDefault();
		await setIsLoading(true)
		if (accountData?.LoginInfo?.Password === accountData?.LoginInfo?.ConfirmPassword) {
			accountData.UserInfo.Salutation = 0
			let accountTypes = _.find(accountTypeItems.result.items, ['Name', 'Transporter']);
			if (accountTypes) {
				accountData.AccountInfo.Name = `${accountData?.UserInfo?.FirstName} ${accountData?.UserInfo?.LastName}`
				accountData.AccountInfo.TypeId = 190 //accountTypes.Id
				accountData.AccountInfo.IsPersonAccount = false
				accountData.AccountInfo.MappedAccountTypes.MappedAccountTypeIds = [accountTypes.Id]
				accountData.AccountAddress.PrimaryAddress = accountData?.Address
				accountData.AccountAddress.PrimaryAddress.FaxNumber = accountData?.LoginInfo.PhoneNumber
				accountData.AccountAddress.PrimaryAddress.GeocodeAccuracy = 0,
					accountData.AccountAddress.PrimaryAddress.Latitude = 0,
					accountData.AccountAddress.PrimaryAddress.Longitude = 0,
					accountData.AccountAddress.PrimaryAddress.OpeningHoursTypeId = 30,
					accountData.AccountAddress.IsUsePrimaryAddressAsBillingAddress = true
				accountData.AccountAddress.IsUsePrimaryAddressAsShippingAddress = true
				accountData.AccountAddress.BillingAddress = {}
				accountData.AccountAddress.ShippingAddress = {}
				const data = _.omit(accountData, 'Address');
				dispatch(accounts.create({
					url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts`, entity: 'accounts', jsonData: {
						Records: [
							{
								Context: {},
								Message: data
							}
						]
					}
				})).then(() => {
					setIsLoading(false)
					handleClose()
				})
			} else {
				setIsLoading(false)
				toast.error("Unable to register now. Please contact support.")
			}
		} else {
			setIsLoading(false)
			toast.error("Password and Confirm Password must be same.")
		}
	}
	return (
		<>
			{accountTypeItems?.isLoading ? <PageLoader /> :
				<>
					{(width && width < 724) ?
						//Mobile view
						<form >
							<div className="flex w-full h-full bg-[#FFFAEF] overflow-auto my-24">
								<div className="flex flex-col w-full content-center items-center justify-start h-full">
									<div className="w-full flex justify-center items-center text-xl font-bold p-3">
										Create your Transporter account
									</div>

									<div className="flex w-full md:w-2/3 flex-col bg-white justify-start items-start h-max p-10 mx-10">
										<div className="flex flex-col justify-start items-start w-full text-base font-bold">
											Personal Information
										</div>
										<div className="text-sm text-black text-opacity-40 pb-2">
											Fill your Personal details here.
										</div>
										<div className="flex w-full flex-col md:flex-row md:space-x-5">
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="FirstName"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'UserInfo.FirstName',
															accountData?.UserInfo
														)
													}}
													{...register('FirstName', { required: true, minLength: 1, maxLength: 30 })}
													onChange={(e: any) => handleSteps(e, 'FirstName')}
													type="text"
													value={accountData?.UserInfo?.FirstName}
												/>
												{errors.FirstName && errors.FirstName.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.FirstName && errors.FirstName.type === "minLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Enter minimum of three characters</span>
												)}
												{errors.FirstName && errors.FirstName.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
												)}
											</div>
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="LastName"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'UserInfo.LastName',
															accountData?.UserInfo
														)
													}}
													type="text"
													{...register('LastName', { required: true, minLength: 1, maxLength: 100 })}
													value={accountData?.UserInfo?.LastName}
												/>
												{errors.LastName && errors.LastName.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.LastName && errors.LastName.type === "minLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Enter minimum of three characters</span>
												)}
												{errors.LastName && errors.LastName.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
												)}
											</div>
										</div>
										<div className="flex w-full flex-col md:flex-row md:space-x-5">
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="Email"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'LoginInfo.Email',
															accountData?.LoginInfo
														)
													}}
													{...register('Email', {
														required: true,
														pattern:
															/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
													})}
													type="text"
													value={accountData?.LoginInfo?.Email}
												/>
												{errors.Email && errors.Email.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.Email && errors.Email.type === "pattern" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
												)}
											</div>

											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="Mobile Number"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'LoginInfo.PhoneNumber',
															accountData?.LoginInfo
														)
													}}
													{...register('PhoneNumber', {
														required: true,
														maxLength: 10,
														minLength: 10,
														pattern: /^[0-9+-]+$/
													})}
													type="phonenumber"
													value={accountData?.LoginInfo?.PhoneNumber}
												/>
												{errors.PhoneNumber && errors.PhoneNumber.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.PhoneNumber && errors.PhoneNumber.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid mobile number</span>
												)}
												{errors.PhoneNumber && errors.PhoneNumber.type === "minLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid mobile number</span>
												)}
												{errors.PhoneNumber && errors.PhoneNumber.type === "pattern" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid mobile number</span>
												)}
											</div>
										</div>
										<div className="flex w-full flex-col md:flex-row md:space-x-5">
											<div className="w-full my-2">
												<InputContainer
													isRequired
													icon
													label="Password"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'LoginInfo.Password',
															accountData?.LoginInfo
														)
													}}
													{...register('Password', { required: true, maxLength: 100 })}
													type="password"
													value={accountData?.LoginInfo?.Password}
												/>
												{errors.Password && errors.Password.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.Password && errors.Password.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
												)}
											</div>
											<div className="w-full my-2">
												<InputContainer
													isRequired
													icon
													label="Confirm Password"
													// name="Password"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'LoginInfo.ConfirmPassword',
															accountData?.LoginInfo
														)
													}}
													{...register('Password', { required: true, maxLength: 100 })}
													type="password"
													value={accountData?.LoginInfo?.ConfirmPassword}
												/>
												{errors.RePassword && errors.RePassword.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.RePassword && errors.RePassword.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
												)}
											</div>
										</div>
										<div className="flex flex-col justify-start items-start w-full text-base font-bold pt-4">
											Address
										</div>
										<div className="text-sm text-black text-opacity-40 pb-2">
											Fill your address here.
										</div>

										<div className="flex w-full flex-col md:flex-row md:space-x-5">
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="Building"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'Address.Address1',
															accountData?.Address
														)
													}}
													{...register('Address1', { required: true, minLength: 3, maxLength: 100 })}
													type="text"
													value={accountData?.Address?.Address1}
												/>
												{errors.Address1 && errors.Address1.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.Address1 && errors.Address1.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
												)}
											</div>
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="Locality"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'Address.Address2',
															accountData?.Address
														)
													}}
													{...register('Address2', { required: true, minLength: 3, maxLength: 100 })}
													type="text"
													value={accountData?.Address?.Address2}
												/>
												{errors.Address2 && errors.Address2.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
											</div>
										</div>
										<div className="flex w-full flex-col md:flex-row md:space-x-5">
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="City"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'Address.City',
															accountData?.Address
														)
													}}
													{...register('City', { required: true, minLength: 3, maxLength: 100 })}
													type="text"
													value={accountData?.Address?.City}
												/>
												{errors.City && errors.City.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.City && errors.City.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
												)}
											</div>
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="Pincode"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'Address.ZipPostalCode',
															accountData?.Address
														)
													}}
													{...register('ZipPostalCode', { required: true, minLength: 6, maxLength: 6 })}

													type="text"
													value={accountData?.Address?.ZipPostalCode}
												/>
												{errors.ZipPostalCode && errors.ZipPostalCode.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.ZipPostalCode && errors.ZipPostalCode.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
												)}
											</div>
										</div>
										<div className="flex w-full flex-col md:flex-row md:space-x-5">
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="Country Name"
													labelField="Name"
													list={countriesItems}
													onValueChange={(event: any, newValue: any) => {
														// handleFilterToStates(event.target.value);
													}}
													{...register('CountryId', { required: true })}
													optionName='Choose Country'
													type="select"
													value={133}  //{accountData?.Address?.CountryId}
													valueField="Id"
													isDisabled={true}

												/>
												{errors.CountryId && errors.CountryId.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
											</div>
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="State Name"
													labelField="Name"
													list={stateValues}
													onValueChange={(event: any, newValue: any) => {
														handleInnerFormChange(
															event.target.value,
															'Address.StateProvinceId',
															accountData?.Address
														);
													}}
													{...register('StateProvinceId', { required: true })}
													optionName='Choose State'
													type="select"
													value={accountData?.Address?.StateProvinceId}
													valueField="Id"
												/>
												{errors.StateProvinceId && errors.StateProvinceId.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
											</div>
										</div>


										<div className="w-full text-center mt-6">
											<button type="submit"
												onClick={handleSubmit}
												className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
													} flex-row flex items-center justify-center text-light rounded font-semibold text-xl p-4 w-full h-11`} >Create Account
												<div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
													<RotatingLines
														visible={true}
														width={'20'}
														strokeColor="#fff"
														strokeWidth="6"
														animationDuration="0.75"
														ariaLabel="rotating-lines-loading"
													/>
												</div></button>


										</div>

										<div className="w-full flex flex-row justify-center my-3 text-md text-black text-opacity-50">
											<div>Already have any account ? </div>
											<div className="font-normal text-black text-opacity-100 cursor-pointer"
												onClick={() => navigate('/auth/login/transporter')}> &nbsp;Login</div>
										</div>
									</div>
								</div>
							</div>
						</form >
						:
						//Web view
						<form >
							<div className="flex w-full h-full bg-[#FFFAEF] pb-10">
								<div className="flex flex-col w-full content-center items-center justify-start h-full">
									<div className="w-full flex justify-center items-center text-3xl font-bold my-4">
										Create your Transporter account
									</div>

									<div className="flex w-full md:w-2/3 flex-col bg-white justify-start items-start h-max p-10 mx-10">
										<div className="flex flex-col justify-start items-start w-full text-2xl font-bold">
											Personal Information
										</div>
										<div className="text-sm text-black text-opacity-40 pb-2">
											Fill your Personal details here.
										</div>
										<div className="flex w-full flex-col md:flex-row md:space-x-5">
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="FirstName"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'UserInfo.FirstName',
															accountData?.UserInfo
														)
													}}
													{...register('FirstName', { required: true, minLength: 1, maxLength: 30 })}
													onChange={(e: any) => handleSteps(e, 'FirstName')}
													type="text"
													value={accountData?.UserInfo?.FirstName}
												/>
												{errors.FirstName && errors.FirstName.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.FirstName && errors.FirstName.type === "minLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Enter minimum of three characters</span>
												)}
												{errors.FirstName && errors.FirstName.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
												)}
											</div>
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="LastName"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'UserInfo.LastName',
															accountData?.UserInfo
														)
													}}
													type="text"
													{...register('LastName', { required: true, minLength: 1, maxLength: 100 })}
													value={accountData?.UserInfo?.LastName}
												/>
												{errors.LastName && errors.LastName.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.LastName && errors.LastName.type === "minLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Enter minimum of three characters</span>
												)}
												{errors.LastName && errors.LastName.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
												)}
											</div>
										</div>
										<div className="flex w-full flex-col md:flex-row md:space-x-5">
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="Email"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'LoginInfo.Email',
															accountData?.LoginInfo
														)
													}}
													{...register('Email', {
														required: true,
														pattern:
															/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
													})}
													type="text"
													value={accountData?.LoginInfo?.Email}
												/>
												{errors.Email && errors.Email.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.Email && errors.Email.type === "pattern" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
												)}
											</div>

											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="Mobile Number"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'LoginInfo.PhoneNumber',
															accountData?.LoginInfo
														)
													}}
													{...register('PhoneNumber', {
														required: true,
														maxLength: 10,
														minLength: 10,
														pattern: /^[0-9+-]+$/
													})}
													type="phonenumber"
													value={accountData?.LoginInfo?.PhoneNumber}
												/>
												{errors.PhoneNumber && errors.PhoneNumber.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.PhoneNumber && errors.PhoneNumber.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid mobile number</span>
												)}
												{errors.PhoneNumber && errors.PhoneNumber.type === "minLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid mobile number</span>
												)}
												{errors.PhoneNumber && errors.PhoneNumber.type === "pattern" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid mobile number</span>
												)}
											</div>
										</div>
										<div className="flex w-full flex-col md:flex-row md:space-x-5">
											<div className="w-full my-2">
												<InputContainer
													isRequired
													icon
													label="Password"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'LoginInfo.Password',
															accountData?.LoginInfo
														)
													}}
													{...register('Password', { required: true, maxLength: 100 })}
													type="password"
													value={accountData?.LoginInfo?.Password}
												/>
												{errors.Password && errors.Password.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.Password && errors.Password.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
												)}
											</div>
											<div className="w-full my-2">
												<InputContainer
													isRequired
													icon
													label="Confirm Password"
													// name="Password"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'LoginInfo.ConfirmPassword',
															accountData?.LoginInfo
														)
													}}
													{...register('Password', { required: true, maxLength: 100 })}
													type="password"
													value={accountData?.LoginInfo?.ConfirmPassword}
												/>
												{errors.RePassword && errors.RePassword.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.RePassword && errors.RePassword.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
												)}
											</div>
										</div>
										<div className="flex flex-col justify-start items-start w-full text-2xl font-bold pt-4">
											Address
										</div>
										<div className="text-sm text-black text-opacity-40 pb-2">
											Fill your address here.
										</div>

										<div className="flex w-full flex-col md:flex-row md:space-x-5">
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="Building"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'Address.Address1',
															accountData?.Address
														)
													}}
													{...register('Address1', { required: true, minLength: 3, maxLength: 100 })}
													type="text"
													value={accountData?.Address?.Address1}
												/>
												{errors.Address1 && errors.Address1.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.Address1 && errors.Address1.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
												)}
											</div>
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="Locality"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'Address.Address2',
															accountData?.Address
														)
													}}
													{...register('Address2', { required: true, minLength: 3, maxLength: 100 })}
													type="text"
													value={accountData?.Address?.Address2}
												/>
												{errors.Address2 && errors.Address2.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
											</div>
										</div>
										<div className="flex w-full flex-col md:flex-row md:space-x-5">
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="City"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'Address.City',
															accountData?.Address
														)
													}}
													{...register('City', { required: true, minLength: 3, maxLength: 100 })}
													type="text"
													value={accountData?.Address?.City}
												/>
												{errors.City && errors.City.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.City && errors.City.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
												)}
											</div>
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="Pincode"
													onValueChange={(event: any) => {
														handleInnerFormChange(
															event.target.value,
															'Address.ZipPostalCode',
															accountData?.Address
														)
													}}
													{...register('ZipPostalCode', { required: true, minLength: 6, maxLength: 6 })}

													type="text"
													value={accountData?.Address?.ZipPostalCode}
												/>
												{errors.ZipPostalCode && errors.ZipPostalCode.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
												{errors.ZipPostalCode && errors.ZipPostalCode.type === "maxLength" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
												)}
											</div>
										</div>
										<div className="flex w-full flex-col md:flex-row md:space-x-5">
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="Country Name"
													labelField="Name"
													list={countriesItems}
													onValueChange={(event: any, newValue: any) => {
														// handleFilterToStates(event.target.value);
													}}
													{...register('CountryId', { required: true })}
													optionName='Choose Country'
													type="select"
													value={133}  //{accountData?.Address?.CountryId}
													valueField="Id"
													isDisabled={true}

												/>
												{errors.CountryId && errors.CountryId.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
											</div>
											<div className="w-full my-2">
												<InputContainer
													isRequired
													label="State Name"
													labelField="Name"
													list={stateValues}
													onValueChange={(event: any, newValue: any) => {
														handleInnerFormChange(
															event.target.value,
															'Address.StateProvinceId',
															accountData?.Address
														);
													}}
													{...register('StateProvinceId', { required: true })}
													optionName='Choose State'
													type="select"
													value={accountData?.Address?.StateProvinceId}
													valueField="Id"
												/>
												{errors.StateProvinceId && errors.StateProvinceId.type === "required" && (
													<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
												)}
											</div>
										</div>
										<div className="w-full text-center mt-6">
											<button type="submit"
												onClick={handleSubmit}
												className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
													} flex-row flex items-center justify-center text-light rounded font-semibold text-xl p-4 w-full h-11`} >Create Account
												<div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
													<RotatingLines
														visible={true}
														width={'20'}
														strokeColor="#fff"
														strokeWidth="6"
														animationDuration="0.75"
														ariaLabel="rotating-lines-loading"
													/>
												</div></button>


										</div>
										<div className="w-full flex flex-row justify-center my-3 text-md text-black text-opacity-50">
											<div>Already have any account ? </div>
											<div className="font-normal text-black text-opacity-100 cursor-pointer"
												onClick={() => navigate('/auth/login/transporter')}> &nbsp;Login</div>
										</div>
									</div>
								</div>
							</div>
						</form >}
				</>
			}
		</>
	);
}
